import React from "react";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import FaqItem from "../components/faq";
import dataFaq from "../assets/fakeData/dataFaq";
import { useState } from "react";
import MobileHeader from "../components/header/MobileHeader";
import NonLoginHeader from "../components/header/NonLoginHeader";

function Faqs(props) {
  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  return (
    <>
      <MobileHeader handleMobile={handleMobile} />
      <NonLoginHeader clname="" handleMobile={handleMobile} />
      {/* <Breadcrumb title="Accordion" /> */}

      <div className="pt-70">
        <FaqItem data={dataFaq} />
        <Footer />
        <Gotop />
      </div>
    </>
  );
}

export default Faqs;
